import classNames from 'classnames'
import React from 'react'
import { DropdownDivider, Nav, NavDropdown } from 'react-bootstrap'
import Navbar from 'react-bootstrap/Navbar'
import { Link, NavLink } from 'react-router'

import { APP_NAME } from '../constants/constants'
import { ROUTES } from '../constants/routes'
import { useLogoutMutation } from '../hooks/useLogoutMutation'
import { useSession } from '../hooks/useSession'
import GlobalSearch from './misc/GlobalSearch/GlobalSearch'
import { SmallContainer } from './misc/SmallContainer'

const AppHeader: React.FC = () => {
  const { session } = useSession()
  const logoutMutation = useLogoutMutation()
  const user = session?.user

  return (
    <Navbar expand="lg" className="bg-body-tertiary" data-bs-theme="dark">
      <SmallContainer>
        <Link to={ROUTES.index} className="navbar-brand">
          {APP_NAME}
        </Link>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="account-dropdown">
          {user && (
            <Nav>
              <NavLink
                to={ROUTES.contactList()}
                className={() =>
                  classNames('nav-link', {
                    active: location.pathname === ROUTES.contactList(),
                  })
                }
              >
                Contacts
              </NavLink>

              <NavLink to={ROUTES.tagList()} className="nav-link me-3">
                Tags
              </NavLink>

              <GlobalSearch />
            </Nav>
          )}

          <Nav className="ms-auto">
            {user ? (
              <NavDropdown title={user.firstName} id="account-dropdown">
                <NavLink to={ROUTES.account()} className="nav-link">
                  Account
                </NavLink>

                <DropdownDivider />

                <NavLink
                  to="#"
                  className="nav-link"
                  onClick={() => logoutMutation.mutate()}
                >
                  {logoutMutation.isPending ? 'Logging out...' : 'Logout'}
                </NavLink>
              </NavDropdown>
            ) : (
              <>
                <NavLink to={ROUTES.login()} className="nav-link">
                  Login
                </NavLink>

                <NavLink to={ROUTES.register()} className="nav-link">
                  Register
                </NavLink>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </SmallContainer>
    </Navbar>
  )
}

export default AppHeader
